import _ from 'lodash';
import classNames from 'classnames';
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { Link } from 'react-router';
import * as actions from '../../../actions/regActions';
import * as clubActions from '../../../actions/clubActions';
import * as memberActions from '../../../actions/memberActions';
import * as eventActions from '../../../actions/eventActions';
import NumberFormat from 'react-number-format';
import alasql from 'alasql';
import * as calcPrice from '../../../components/common/calculatePrice';
import TextareaInput from '../../../components/common/TextareaInput';
import * as utils from '../../../components/common/utils';
// import jsPDF from 'jspdf';

// Special function
alasql.fn.includeEmpty = function(a) {
	if(!a) return [undefined];
	if(a.length == 0) return [undefined];
	return a;
};

alasql.fn.includeEmptyNA = function(a) {
	if(!a) return [99999999];
	if(a.length == 0) return [99999999];
	return a;
};

alasql.fn.includeEmptyArray = function(a) {
	if(!a) return [{}];
	if(a.length == 0) return [{}];
	return a;
};

alasql.aggr.CONCAT_STRINGS = function(value, accumulator, stage) {
		if(stage == 1) {
			// first call of aggregator - for first line
			let newAccumulator = [value];
			return newAccumulator;
		} else if(stage == 2) {
			// for every line in the group
			accumulator.push(value);
			return accumulator;
		} else if(stage == 3) {
			// Post production - please nota that value Will be undefined
			return accumulator.sort().join(', ');
		}
};


class RegSummary extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this);
		this.altHelper = this.altHelper.bind(this);

		this.getContenderObject = this.getContenderObject.bind(this);
		this.renderContenderSummary = this.renderContenderSummary.bind(this);
		this.renderClubRegInfo = this.renderClubRegInfo.bind(this);

    this.getTeamMembers = this.getTeamMembers.bind(this);
    this.getTeamCount = this.getTeamCount.bind(this);
    this.getTeamCategoryCount = this.getTeamCategoryCount.bind(this);
    this.getTeamMemberCategoryCount = this.getTeamMemberCategoryCount.bind(this);

    this.teamLoop = this.teamLoop.bind(this);
    this.teamCategoryLoop = this.teamCategoryLoop.bind(this);
    this.memberCategoryLoop = this.memberCategoryLoop.bind(this);
    // this.downloadPDF = this.downloadPDF.bind(this);
		this.state = {
			member_table: [],
			details: props.details,
			errors: props.errors,
		};
  }

	componentWillMount() {
		if (this.props.show == undefined) {
			if(this.props.clubId) {
				this.props.clubActions.loadClubDetails(this.props.clubId);
				this.props.memberActions.loadClubMembers(this.props.clubId);
			}
			if(this.props.eventId) {
				this.props.eventActions.loadEventTeamSettings(this.props.eventId);
			}
			if (this.props.eventId && this.props.clubId) {
				this.props.actions.loadRegDetails(this.props.eventId, this.props.clubId);
			}
		}
	}

	componentWillReceiveProps(nextProps) {
		if (!_.isEqual(this.props.details, nextProps.details)) {
			let member_table = this.getTeamMembers(nextProps.details);
			this.setState({
				member_table: member_table
			});
			if (nextProps.show == undefined && !nextProps.loading && !_.isEqual(this.props.loading, nextProps.loading)) {
				setTimeout(function(){
					window.print();
				}, 3000);
			}
		}
		if(!_.isEqual(nextProps.details, this.props.details)) {
			this.setState({
				details: nextProps.details,
				errors: {},
			});
		}
		if(!_.isEqual(nextProps.errors, this.props.errors)) {
			this.setState({
				errors: nextProps.errors,
			});
		}
	}

	altHelper(field, prefix) {
		prefix = prefix ? prefix : 'alt_';
		if (this.props.details[prefix+field]) {
			return this.props.details[prefix+field];
		} else {
			return this.props.clubDetails['club_' + field];
		}
	}

	renderClubRegInfo() {
		let clubAddress = utils.join([
			this.altHelper('address'),
			this.altHelper('zip'),
			this.altHelper('municipality'),
			this.altHelper('county'),
			this.altHelper('country')], ", ");
		let billingAddress = utils.join([
			this.altHelper('address', 'billing_'),
			this.altHelper('zip', 'billing_'),
			this.altHelper('municipality', 'billing_'),
			this.altHelper('county', 'billing_'),
			this.altHelper('country', 'billing_')], ", ");

			return (
				<div className="row">
					<div className="col-sm-6">
						<h4 className="page-header">{'Kontaktperson'}</h4>
						<div className="">
							<strong>Navn:</strong>
							<p>{this.altHelper('contact_person')}</p>
							<strong>Epost:</strong>
							<p>{this.altHelper('contact_email')}</p>
							<strong>Tlf:</strong>
							<p>{this.altHelper('contact_phone_number')}</p>
							<strong>Adresse:</strong>
							<p>{clubAddress}</p>
						</div>
					</div>
					<div className="col-sm-6">
						<h4 className="page-header">{'Fakturaadresse'}</h4>
						<div className="">
							<strong>Kontaktperson:</strong>
							<p>{this.altHelper('contact_person', 'billing_')}</p>
							<strong>Epost:</strong>
							<p>{this.altHelper('email', 'billing_')}</p>
							<strong>Adresse:</strong>
							<p>{billingAddress}</p>
						</div>
					</div>
				</div>
			);
	}

	getContenderObject(details, eventDetails) {
		let contenderCount = _.size(details.member_registrations);
		let contenderPrice = contenderCount * eventDetails.price_contender;
		return {count: contenderCount, price: contenderPrice};
	}

	renderContenderSummary() {
		let contenderSummary = this.getContenderObject(this.props.details,
			this.props.eventDetails);
		return (
			<div>
				<h4 className="page-header">Deltagere</h4>
					{'Antall: '+ contenderSummary.count}
					<br/>
					{!!contenderSummary.price && 'Pris: '}
					<NumberFormat value={contenderSummary.price}
						displayType={'text'}
						thousandSeparator={'.'}
						decimalSeparator={','} suffix={' kr.'} />
			</div>
		);
	}

  getTeamMembers(details) {
    let members = alasql(`
      SEARCH teams / AS @team
        EX(includeEmptyArray(members)) / AS @member
        EX(includeEmptyNA(categories)) / AS @category
        RETURN (
          @team->id AS [team_id],
          @team->team_category AS [team_category_id],
          @team->team_type AS [team_type_id],
          @member->id AS [reg_id],
          @member->member_reg AS [member_id],
          @member->member_reg_details->member_details->first_name AS [first_name],
          @member->member_reg_details->member_details->last_name AS [last_name],
					@category as member_category_id
        )
      FROM ?
    `, [details]);
		return members;
  }

	getTeamCount(member_table, team) {
		return alasql(`
			SELECT team_type_id, COUNT(DISTINCT team_id) AS team_count FROM ?
			WHERE team_type_id == ?
			GROUP BY team_type_id
		`, [member_table, team.id]);
	}

	getTeamCategoryCount(member_table, category) {
		return alasql(`
			SELECT team_category_id,
				COUNT(DISTINCT team_id) AS [count]
			FROM ?
			WHERE team_category_id == ?
			GROUP BY team_category_id
		`, [member_table, category.id]);
	}

	getTeamMemberCategoryCount(member_table, category, team) {
		return alasql(`
			SELECT member_category_id,
				COUNT(DISTINCT member_id) AS [count]
			FROM ?
			WHERE member_category_id == ?
				AND team_category_id == ?
			GROUP BY member_category_id
		`, [member_table, category.id, team.id]);
	}

	teamLoop(teamList) {
		return teamList.map((team, index) => {
			// let teamCount = this.getTeamCount(this.state.member_table, team);
			// <span className="label label-default">{teamCount[0].team_count}</span>
			let teamTypePrice = calcPrice.calculateTeamTypePrice(this.props.details,
				team)
			return (
				<div className="col-sm-6 reg-sum-item" key={index}>
					<h4 className="page-header">{team.name}</h4>
					{this.teamCategoryLoop(team)}
					<h5 className="">
						{'Pris: '}
						<NumberFormat value={teamTypePrice}
							displayType={'text'}
							thousandSeparator={'.'}
							decimalSeparator={','} suffix={' kr.'} />
						{!teamTypePrice && '0 kr.'}
					</h5>

				</div>
			);
		});
	}

	teamCategoryLoop(team) {
		return team.team_categories.map((category, cat_index) => {
			let teamCategoryCount = this.getTeamCategoryCount(this.state.member_table,
				category);
			let member_categories = this.memberCategoryLoop(category);
			if (teamCategoryCount[0].count == 0) {
				return null;
			}
			return (
				<div key={cat_index}>
					<h5>
						{!team.static_categories && <span>
							<span className="label label-default">
								{teamCategoryCount[0].count}
							</span>
							{' x '}
						</span>}
						{category.name}
					</h5>
					{member_categories}
				</div>
			);
		});
	}

	memberCategoryLoop(team_category) {
		let no_cat_count = this.getTeamMemberCategoryCount(
			this.state.member_table,
			{id: 99999999},
			team_category);
		if (_.isEmpty(team_category.member_categories)) {
			return (<div  className="member_categories_report">
				<span className="label label-default">{no_cat_count[0].count}</span>
				{' '} &times;
				{' Medlemmer'}
			</div>);
		} else {
			return (<div className="member_categories_report">
				{(no_cat_count[0].count > 0) && <span>
					<span className="label label-default">{no_cat_count[0].count}</span>
					{' '} &times; {' '}
					{'Uten kategori'}
					{', '}
				</span>}
				{team_category.member_categories.map((category, cat_index) => {
					let count = this.getTeamMemberCategoryCount(
						this.state.member_table,
						category,
						team_category);
					return (
						(count[0].count > 0) && <span key={cat_index}>
							<span className="label label-default">{count[0].count}</span>
							{' '} &times; {' '}
							{category.name}
							{', '}
						</span>
					);
				})}
			</div>);
		}
	}

	// downloadPDF() {
	// 	let doc = new jsPDF();
	// 	doc.fromHTML($('#summary-report').get(0), 15, 15, {
	// 		'width': 170
	// 	});
	// 	doc.save('report.pdf');
	// }


  render() {
		if (this.props.show === false) {
      return null;
    }
		let totalpris = calcPrice.calculatePrice(this.props.details,
			this.props.teamList, this.props.eventDetails);
    return (
      <div>
				<div className={classNames("panel panel-default", {
						'hidden': !this.props.show
					})}>
					<div className="panel-heading">
						<h4 className="panel-title">Kommentar til påmeldingen</h4>
					</div>
					<div className="panel-body">
						<TextareaInput
							error={this.state.errors.comment}
							diffObject={this.props.detailsDiff}
							name="comment"
							onChange={this.props.updateField}
							value={this.state.details.comment}
							helpText="OBS! Husk å lagre endringene i kommentarfeltet."
							/>
					</div>
				</div>
      	<div className="panel panel-default">
					<div className="panel-heading clearfix">
						<h4 className="panel-title panel-heading-w-btn pull-left">Oppsummering</h4>
						<div className={classNames("pull-right", {
								'hidden': !this.props.show
							})}>
							<Link className="btn btn-primary"
								target="_blank"
								to={'/arrangement/'+
									this.props.eventId +
									'/registrer/klubb/'+
									this.props.clubId +
									'/oppsummering/print'}>
								Print
							</Link>
						</div>
					</div>
      	  <div className="panel-body" id="summary-report">
						{this.renderClubRegInfo()}
						{this.renderContenderSummary()}
						<div className="row">
							{this.teamLoop(this.props.teamList)}
						</div>
						<div>
							<h4 className="page-header">Totalt</h4>
							<strong>
								{'Total pris: '}
								<NumberFormat value={totalpris}
									displayType={'text'}
									thousandSeparator={'.'}
									decimalSeparator={','} suffix={' kr.'} />
							</strong>
							<br/>
						</div>
						{(this.props.savedComment || (!this.props.show && this.props.details.comment)) && <div>
							<h4 className="page-header">
								Kommentar til påmeldingen
							</h4>
							<p>{this.props.savedComment || this.props.details.comment}</p>
						</div>}
      	  </div>
      	</div>
      </div>
    );
  }
}

RegSummary.propTypes = {
  actions: PropTypes.object.isRequired,
  clubActions: PropTypes.object.isRequired,
  detailsDiff: PropTypes.object,
  memberActions: PropTypes.object.isRequired,
  eventActions: PropTypes.object.isRequired,
  savedComment: PropTypes.string,
  details: PropTypes.object.isRequired,
	errors: PropTypes.object,
  teamList: PropTypes.array.isRequired,
  eventDetails: PropTypes.object.isRequired,
  clubDetails: PropTypes.object.isRequired,
  eventId: PropTypes.string.isRequired,
  clubId: PropTypes.string.isRequired,
  detailsUpdated: PropTypes.number,
  loading: PropTypes.bool,
  updateField: PropTypes.func,
  show: PropTypes.bool,
};

function mapStateToProps(state, ownProps) {
  return {
    loading: state.registration.loading,
    eventDetails: state.events.eventDetails,
    details: ownProps.details ||state.registration.details,
    errors: ownProps.errors ||state.registration.errors,
    teamList: state.events.teamList,
    clubDetails: state.clubs.clubDetails,
    eventId: ownProps.eventId || ownProps.params.eventId,
    clubId: ownProps.clubId || ownProps.params.clubId,
    detailsUpdated: state.registration.detailsUpdated,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
		clubActions: bindActionCreators(clubActions, dispatch),
    memberActions: bindActionCreators(memberActions, dispatch),
    eventActions: bindActionCreators(eventActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegSummary);



/** WEBPACK FOOTER **
 ** ./src/containers/events/register/RegSummary.js
 **/